module.exports = __webpack_public_path__ + "img/imgexchangebtn.a0bd644a.png";